import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { createTechStack, removeTechStack } from "./api";
import { invalidateAllQueries } from "utils/utils";
import { eventBus } from "utils/eventBus";

export function useRemoveTechStack({ ...options } = {}) {
    return useMutation({
        mutationFn: ({ id }) => removeTechStack(id),
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Removed tech stack Successfully");
            options.onSuccess?.();
        },
        onError: () => {
            toast.error("Error Removing tech stack");
        },
    });
}

export function useCreateTechStack({ casestudyId, ...options } = {}) {
    return useMutation({
        mutationFn: ({ item }) => createTechStack({ item }),
        onSuccess: (data) => {
            invalidateAllQueries();
            eventBus.emit("refresh:list", `case_studies_tech_stacktechstack${casestudyId}`);
            toast.success("Tech stack created");
            options.onSuccess?.(data);
        },
        onError: (err) => {
            toast.error("Error creating tech stack");
            options.onError?.(err);
        },
    });
}